<template>
  <div class="content">
    <div class="container">
      <div class="modular-title"  v-if="type != 2">
        <div class="title-left">
          <div class="title-line"></div>
          <div>{{ data.title }}</div>
        </div>
      </div>
      <div v-html="getnode(data.content)"></div>
    </div>

  </div>
</template>

<script>
/**
@description:文章详情
@createTime:2021-09-17
@create:wq
*/
import { formatRichText } from "../../../utils/tool";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      id: "",
      data: "",
      cflag: true,
      sendText: "",
      type:''
    };
  },
  computed: {
    getnode() {
      return function(html) {
        return formatRichText(html);
      };
    },
  },
  watch: {},
  mounted() {},
  created() {
    // type == 2 首页轮播点击进入
    this.type = this.$route.query.type
    if (
      this.$route.query &&
      this.$route.query.type != 2 &&
      this.$route.query.id
    ) {
      this.id = this.$route.query.id;
      this.getdata();
    } else if (this.$route.query && this.$route.query.type == 2) {
      this.id = this.$route.query.id;
      this.getdata1();
    }
  },
  methods: {
    getdata() {
      this.api.articleDetails({ id: this.id }).then((res) => {
        this.data = res.data;
      });
    },
    getdata1() {
      this.api.pages({ id: this.id }).then((res) => {
        this.data = res.data;
        this.data.content = res.data.contents;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background: #f1f1f1;
}
.container {
  background: #fff;
  padding: 0.4rem 0.24rem;
}
.flex_b {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex_c {
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-msg {
  display: flex;
  margin-bottom: 0.3rem;
  align-items: center;
  .user-img {
    width: 0.8rem;
    height: 0.8rem;
    margin-right: 0.32rem;
  }
  .name {
    font-size: 0.32rem;
    color: #4cd8d4;
    line-height: 1;
    margin-bottom: 0.13rem;
  }
  .timer {
    color: #999;
    font-size: 0.25rem;
    line-height: 1;
  }
  .focus {
    color: #4cd8d4;
    border: 1px solid #4cd8d4;
    width: 1.3rem;
    height: 0.6rem;
    font-size: 0.3rem;
    background: rgba(76, 216, 212, 0.1);
    border-radius: 0.3rem;
    text-align: center;
    line-height: 0.6rem;
  }
}
.modular-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.4rem;

  .title-left {
    font-size: 0.32rem;
    font-weight: bold;
    color: #333333;
    display: flex;
    align-items: center;
    .title-line {
      width: 4px;
      height: 16px;
      background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
      opacity: 1;
      border-radius: 0px 4px 4px 0px;
      margin-right: 6px;
    }
  }

  .look-more {
    font-size: 0.22rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    span {
      margin-right: 6px;
    }
    i {
      font-size: 0.2rem;
    }
  }
}

</style>
